import {
  AttributeFilterOperator,
  AttributeFilterType,
  relevantOperators,
  TypeByOperator,
} from "@reflag/shared/attributeFilter";

export function attributeOperators(
  type?: AttributeFilterType,
  currentOperator?: AttributeFilterOperator,
  isInferred = false,
) {
  const operators = relevantOperators(
    type
      ? type === "text" || (isInferred && type !== "array")
        ? [type, "any", "list"]
        : [type]
      : ["any", "date", "text", "number", "list", "boolean"],
  );

  // An observed type must never hide or rewrite an existing rule's operator.
  if (
    (isInferred || type === "array") &&
    currentOperator &&
    !Object.values(operators).flat().includes(currentOperator)
  ) {
    operators[TypeByOperator[currentOperator]] = [currentOperator];
  }
  return operators;
}
